import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { FaPlus, FaMinus, FaArrowRight } from "react-icons/fa";
import Img1 from "./zapier.png";
import Img2 from "./whatsMail.png";
import Img3 from "./facebook1.png";
import Img4 from "./crm.png";

const AccordionSection = () => {
  const [count, setCount] = useState({
    managed: 1,
    cloud: 1,
  });

  const [addedModules, setAddedModules] = useState([]);

  const modules = [
    {
      name: "Zoho CRM",
      id: "zoho",
      basic: "-",
      pro: 15,
      ultimate: 0,
      image: Img4,
    },
    {
      name: "WhatsMail",
      id: "whatsmail",
      basic: "-",
      pro: 10,
      ultimate: 0,
      image: Img2,
    },
    {
      name: "Zapier",
      id: "zapier",
      basic: "-",
      pro: 18,
      ultimate: 0,
      image: Img1,
    },
    {
      name: "Facebook Leads",
      id: "facebook",
      basic: "-",
      pro: 20,
      ultimate: 0,
      image: Img3,
    },
  ];

  const defaultRows = [
    { name: "Base Plan Rent", basic: 14, pro: 29, ultimate: 49 },
    {
      name: "WhatsApp Cloud API",
      basic: 0,
      pro: 0,
      ultimate: 10,
    },
    { name: "WhatsApp Fully Managed", basic: 24, pro: 24, ultimate: 19 },
  ];

  const [rows, setRows] = useState([...defaultRows]);

  const handleAddModule = (id) => {
    const moduleToAdd = modules.find((m) => m.id === id);
    if (!addedModules.includes(id)) {
      setAddedModules([...addedModules, id]);
      setRows([...rows, moduleToAdd]); // Add module to rows
    }
  };

  const handleRemoveModule = (id) => {
    setAddedModules(addedModules.filter((module) => module !== id));
    setRows(rows.filter((row) => row.id !== id)); // Remove module from rows
  };

  const calculateTotal = (column) => {
    return rows.reduce((acc, row) => {
      const value = row[column];
      return acc + (typeof value === "number" ? value : 0);
    }, 0);
  };

  useEffect(() => {
    // Dynamically add or update rows based on count values
    const updatedRows = [...defaultRows];

    if (count.managed > 1) {
      updatedRows.push({
        name: "WhatsApp Fully Managed",
        basic: 0,
        pro: 0,
        ultimate:
          defaultRows[2].ultimate * count.managed - defaultRows[2].ultimate,
      });
    }

    if (count.cloud > 1) {
      updatedRows.push({
        name: "WhatsApp Cloud API",
        basic: 0,
        pro: 0,
        ultimate:
          defaultRows[1].ultimate * count.cloud - defaultRows[1].ultimate,
      });
    }

    setRows(
      updatedRows.concat(modules.filter((m) => addedModules.includes(m.id)))
    );
  }, [count, addedModules]);

  return (
    <Box p={3}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={4}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#FFFFFF",
              padding: "10px 15px",
              borderRadius: "10px",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
              marginBottom: "15px",
              border: "1px solid transparent", // Default border
              transition: "all 0.3s ease-in-out", // Smooth transition for border and position
              "&:hover": {
                border: "1px solid #6ccf98", // Green border on hover
                transform: "translateY(-8px)", // Move upward on hover
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <img
                src="https://cdn-icons-png.flaticon.com/512/733/733585.png" // Replace with your icon URL
                alt="WhatsApp Icon"
                style={{ width: "30px", height: "30px" }}
              />
              <Typography fontWeight="bold">WhatsApp Fully Managed</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#e9f5ee",
                borderRadius: "10px",
                padding: "4px",
              }}
            >
              <IconButton
                sx={{
                  backgroundColor: "#6ccf98",
                  color: "white",
                  borderRadius: "5px",
                  padding: "5px",
                  "&:hover": {
                    backgroundColor: "#5ab982",
                  },
                }}
                onClick={() =>
                  setCount({
                    ...count,
                    managed: Math.max(1, count.managed - 1),
                  })
                }
              >
                <FaMinus />
              </IconButton>
              <Typography
                sx={{
                  marginX: "8px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  color: "#333",
                }}
              >
                {count.managed}
              </Typography>
              <IconButton
                sx={{
                  backgroundColor: "#6ccf98",
                  color: "white",
                  borderRadius: "5px",
                  padding: "5px",
                  "&:hover": {
                    backgroundColor: "#5ab982",
                  },
                }}
                onClick={() =>
                  setCount({
                    ...count,
                    managed: count.managed + 1,
                  })
                }
              >
                <FaPlus />
              </IconButton>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#FFFFFF",
              padding: "10px 15px",
              borderRadius: "10px",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
              marginBottom: "15px",
              border: "1px solid transparent", // Default border
              transition: "all 0.3s ease-in-out", // Smooth transition for border and position
              "&:hover": {
                border: "1px solid #6ccf98", // Green border on hover
                transform: "translateY(-8px)", // Move upward on hover
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <img
                src="https://cdn-icons-png.flaticon.com/512/733/733585.png" // Replace with your icon URL
                alt="WhatsApp Icon"
                style={{ width: "30px", height: "30px" }}
              />
              <Typography fontWeight="bold">WhatsApp Cloud API</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#e9f5ee",
                borderRadius: "10px",
                padding: "4px",
              }}
            >
              <IconButton
                sx={{
                  backgroundColor: "#6ccf98",
                  color: "white",
                  borderRadius: "5px",
                  padding: "5px",
                  "&:hover": {
                    backgroundColor: "#5ab982",
                  },
                }}
                onClick={() =>
                  setCount({
                    ...count,
                    cloud: Math.max(1, count.cloud - 1),
                  })
                }
              >
                <FaMinus />
              </IconButton>
              <Typography
                sx={{
                  marginX: "8px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  color: "#333",
                }}
              >
                {count.cloud}
              </Typography>
              <IconButton
                sx={{
                  backgroundColor: "#6ccf98",
                  color: "white",
                  borderRadius: "5px",
                  padding: "5px",
                  "&:hover": {
                    backgroundColor: "#5ab982",
                  },
                }}
                onClick={() =>
                  setCount({
                    ...count,
                    cloud: count.cloud + 1,
                  })
                }
              >
                <FaPlus />
              </IconButton>
            </Box>
          </Box>
        </Grid>

        {modules.map((module) => (
          <Grid item xs={12} md={6} lg={4} key={module.id}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#FFFFFF",
                padding: "10px 15px",
                borderRadius: "10px",
                boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                border: "1px solid transparent", // Default border
                transition: "all 0.3s ease-in-out", // Smooth transition for border and position
                "&:hover": {
                  border: "1px solid #6ccf98", // Green border on hover
                  transform: "translateY(-8px)", // Move upward on hover
                },
                marginBottom: "15px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                {/* Replace with module-specific icons */}
                <img
                  src={module.image} // Replace with actual icon paths
                  alt={`${module.name} Icon`}
                  style={{ width: "30px", height: "30px" }}
                />
                <Typography fontWeight="bold">{module.name}</Typography>
              </Box>
              {addedModules.includes(module.id) ? (
                <Button
                  sx={{
                    backgroundColor: "#6ccf98",
                    color: "white",
                    fontWeight: "bold",
                    borderRadius: "20px",
                    textTransform: "none",
                    padding: "5px 15px",
                    "&:hover": {
                      backgroundColor: "#5ab982",
                    },
                  }}
                  onClick={() => handleRemoveModule(module.id)}
                >
                  Added
                </Button>
              ) : (
                <Button
                  sx={{
                    color: "#6ccf98",
                    border: "1px solid #6ccf98",
                    fontWeight: "bold",
                    borderRadius: "20px",
                    textTransform: "none",
                    padding: "5px 15px",
                    "&:hover": {
                      backgroundColor: "#e9f5ee",
                    },
                  }}
                  onClick={() => handleAddModule(module.id)}
                >
                  Add +
                </Button>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box mt={5}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
             

              <TableRow>
                <TableCell>
                  <Typography
                    sx={{
                      backgroundColor: "#4A90E2",
                      color: "white",
                      fontWeight: "bold",
                      borderRadius: "15px",
                      padding: "8px 16px",
                      fontSize: "14px",
                      display: "inline-block", // Ensures it's an inline element for proper layout
                    }}
                  >
                    ADON
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                   
                  }}
                >
                  <Typography
                    sx={{
                      backgroundColor: "#F53F69",
                      color: "white",
                      fontWeight: "bold",
                      borderRadius: "15px",
                      padding: "8px 16px",
                      fontSize: "14px",
                      display: "inline-block",
                    }}
                  >
                    Basic
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                   
                  }}
                >
                  <Typography
                    sx={{
                      backgroundColor: "#F89536",
                      color: "white",
                      fontWeight: "bold",
                      borderRadius: "15px",
                      padding: "8px 16px",
                      fontSize: "14px",
                      display: "inline-block",
                    }}
                  >
                    Pro
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    
                  }}
                >
                  <Typography
                    sx={{
                      backgroundColor: "#5B6CE5",
                      color: "white",
                      fontWeight: "bold",
                      borderRadius: "15px",
                      padding: "8px 16px",
                      fontSize: "14px",
                      display: "inline-block",
                    }}
                  >
                    Ultimate
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell
                    sx={{ textAlign: "center", verticalAlign: "middle" }}
                  >
                    {row.basic}
                  </TableCell>
                  <TableCell
                    sx={{ textAlign: "center", verticalAlign: "middle" }}
                  >
                    {row.pro}
                  </TableCell>
                  <TableCell
                    sx={{ textAlign: "center", verticalAlign: "middle" }}
                  >
                    {row.ultimate}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell>
                  <b>Total</b>
                </TableCell>
                <TableCell
                  sx={{ textAlign: "center", verticalAlign: "middle" }}
                >
                  <b>${calculateTotal("basic").toFixed(2)}</b>
                </TableCell>
                <TableCell
                  sx={{ textAlign: "center", verticalAlign: "middle" }}
                >
                  <b>${calculateTotal("pro").toFixed(2)}</b>
                </TableCell>
                <TableCell
                  sx={{ textAlign: "center", verticalAlign: "middle" }}
                >
                  <b>${calculateTotal("ultimate").toFixed(2)}</b>
                </TableCell>
              </TableRow>
              
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default AccordionSection;
